import { Configuration, LogLevel } from "@azure/msal-browser";

const tenantId = import.meta.env.VITE_AAD_TENANT_ID ?? "common";
const clientId = import.meta.env.VITE_AAD_CLIENT_ID ?? "";

export const ALLOWED_GROUP_OID: string =
  import.meta.env.VITE_ALLOWED_GROUP_OID ?? "";

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) console.error(message);
      },
      logLevel: LogLevel.Warning
    }
  }
};

export const graphScopes = [
  "User.Read",
  "Team.ReadBasic.All",
  "Channel.ReadBasic.All",
  "ChannelMessage.Read.All",
  "TeamMember.Read.All",
  "Group.ReadWrite.All",
  "Mail.Send",
  "Files.Read.All",
  "Sites.Read.All"
];

export const apiScopes = [`api://${clientId}/access_as_user`];
